// extracted by mini-css-extract-plugin
module.exports = {"noSpecial":"subTable_noSpecial__2rjCB"};